import React, { PropsWithChildren } from 'react';
import { Formik, Form as FormikForm } from 'formik';
import { IForm } from './types';

import Input from './components/Input';
import Textarea from './components/Textarea';
import Select from './components/Select';
import SubmitButton from './components/SubmitButton';
import GenderSwitch from './components/GenderSwitch';

function Form<T = Record<string, unknown>>(props: PropsWithChildren<IForm<T>>) {
  const { className, children, formik } = props;

  return (
    // @ts-ignore
    <Formik {...formik}>
      <FormikForm className={className}>{children}</FormikForm>
    </Formik>
  );
}

export default Object.assign(Form, {
  Input,
  Textarea,
  Select,
  SubmitButton,
  GenderSwitch,
});
